
/* Iron Mom storefront script. window.IronMom = { mode: 'preview' | 'shopify' } */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('js');
  var cfg = window.IronMom || { mode: 'preview' };
  var isPreview = cfg.mode !== 'shopify';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* ---------- mobile nav ---------- */
  function initNav() {
    var header = $('.site-header'), btn = $('.menu-btn');
    if (!header || !btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('.nav a', header).forEach(function (a) {
      a.addEventListener('click', function () { header.classList.remove('nav-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* ---------- scroll reveals ---------- */
  function initReveal(scope) {
    $$('[data-stagger]', scope).forEach(function (g) {
      $$('.reveal', g).forEach(function (el, i) { el.style.setProperty('--d', (i * 0.08) + 's'); });
    });
    var els = $$('.reveal', scope);
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- stat count-up ---------- */
  function initCount(scope) {
    if (reduce.matches || !('IntersectionObserver' in window)) return;
    $$('[data-count]', scope).forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-count'));
      if (!to) return;
      el.textContent = '0';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = 1400;
        (function frame(t) {
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * e);
          if (p < 1) requestAnimationFrame(frame);
        })(t0);
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---------- pause looping animations while off-screen (performance) ---------- */
  var offIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var off = !e.isIntersecting;
      e.target.classList.toggle('is-offscreen', off);
      $$('svg[data-smil]', e.target).forEach(function (sv) {
        if (!sv.pauseAnimations || reduce.matches) return;
        if (off) sv.pauseAnimations(); else sv.unpauseAnimations();
      });
    });
  }, { rootMargin: '100px 0px' }) : null;
  function initOffscreen(scope) {
    if (!offIO) return;
    $$('.bs, .wall, .hero-art, .ticker', scope).forEach(function (el) { offIO.observe(el); });
  }

  /* ---------- product gallery swatches ---------- */
  function initGallery(scope) {
    $$('[data-gallery]', scope).forEach(function (g) {
      var slides = $$('.slide', g), thumbs = $$('.thumb', g);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('active', i === j); });
          thumbs.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- faq accordion ---------- */
  function initFaq(scope) {
    $$('.faq details', scope).forEach(function (det) {
      var sum = $('summary', det), body = $('.answer', det);
      if (!sum || !body || !body.animate) return;
      sum.addEventListener('click', function (e) {
        if (reduce.matches) return;
        e.preventDefault();
        if (det.open) {
          var h = body.scrollHeight;
          det.classList.add('closing');
          body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 260, easing: 'ease' }).onfinish = function () { det.open = false; det.classList.remove('closing'); };
        } else {
          det.open = true;
          var h2 = body.scrollHeight;
          body.animate([{ height: '0px' }, { height: h2 + 'px' }], { duration: 280, easing: 'ease' });
        }
      });
    });
  }

  /* ---------- supplement facts zoom ---------- */
  function initZoom(scope) {
    $$('[data-zoom]', scope).forEach(function (btn) {
      var dlg = d.getElementById(btn.getAttribute('data-zoom'));
      if (!dlg || !dlg.showModal) { btn.hidden = true; return; }
      btn.addEventListener('click', function () { dlg.showModal(); });
      $('.close', dlg).addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });
  }

  /* ---------- cart ---------- */
  var Cart = { items: [], total: null, opener: null };
  var drawer = $('#cart-drawer'), overlay = $('.drawer-overlay');

  Cart.open = function (from) {
    if (!drawer) return;
    Cart.opener = from || d.activeElement;
    root.classList.add('cart-open');
    drawer.removeAttribute('inert');
    setTimeout(function () { var c = $('.icon-btn', drawer); if (c) c.focus(); }, 60);
  };
  Cart.close = function () {
    root.classList.remove('cart-open');
    if (drawer) drawer.setAttribute('inert', '');
    if (Cart.opener && Cart.opener.focus) Cart.opener.focus();
  };

  Cart.render = function () {
    if (!drawer) return;
    var count = 0, total = 0;
    Cart.items.forEach(function (i) { count += i.qty; total += i.qty * i.price; });
    if (Cart.total != null) total = Cart.total;
    $$('[data-cart-count]').forEach(function (el) {
      if (el.textContent !== String(count)) {
        el.textContent = count;
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      }
    });
    var body = $('.drawer-body', drawer), foot = $('.drawer-foot', drawer);
    if (!Cart.items.length) {
      body.innerHTML = '<div class="drawer-empty"><p>Your cart is empty. Add a tin to get started.</p><a class="btn" href="#shop" data-cart-close>Shop Vitality Iron Strips</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = Cart.items.map(function (i) {
      var img = i.image ? '<img src="' + esc(i.image) + '" alt="" width="72" height="72">' : '<div class="ph">photo</div>';
      return '<div class="line" data-key="' + esc(i.key) + '">' +
        '<div class="line-img">' + img + '</div>' +
        '<div><h3>' + esc(i.title) + '</h3><p class="plan-label">' + esc(i.planLabel) + '</p>' +
        '<div class="qty"><button type="button" data-line-step="-1" aria-label="Decrease quantity of ' + esc(i.title) + '">&minus;</button>' +
        '<input type="number" min="0" max="99" value="' + i.qty + '" aria-label="Quantity" data-line-qty>' +
        '<button type="button" data-line-step="1" aria-label="Increase quantity of ' + esc(i.title) + '">+</button></div></div>' +
        '<div><div class="line-price">' + money(i.price * i.qty) + '</div><button type="button" class="remove" data-line-remove>Remove</button></div>' +
        '</div>';
    }).join('');
    $('[data-subtotal]', drawer).textContent = money(total);
  };

  Cart.refresh = function () {
    if (isPreview) { Cart.render(); return Promise.resolve(); }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        Cart.total = c.total_price;
        Cart.items = c.items.map(function (i) {
          var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          return {
            key: i.key, title: i.product_title, qty: i.quantity, price: i.final_price, image: img,
            planLabel: i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : 'One-time purchase'
          };
        });
        Cart.render();
      });
  };

  Cart.add = function (item) {
    if (isPreview) {
      var key = 'p-' + (item.planId || 'once');
      var found = Cart.items.filter(function (i) { return i.key === key; })[0];
      if (found) found.qty = Math.min(99, found.qty + item.qty);
      else Cart.items.push({ key: key, title: item.title, planLabel: item.planLabel, qty: item.qty, price: item.price, image: item.image });
      Cart.render();
      return Promise.resolve();
    }
    var line = { id: parseInt(item.variantId, 10), quantity: item.qty };
    if (item.planId) line.selling_plan = parseInt(item.planId, 10);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'This item could not be added. Try again.');
        return Cart.refresh();
      });
    });
  };

  Cart.change = function (key, qty) {
    qty = Math.max(0, Math.min(99, qty));
    if (isPreview) {
      Cart.items = Cart.items.filter(function (i) { if (i.key === key) i.qty = qty; return i.qty > 0; });
      Cart.render();
      return;
    }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(Cart.refresh);
  };

  function initCart() {
    if (!drawer) return;
    drawer.setAttribute('inert', '');
    d.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); Cart.open(opener); return; }
      var closer = e.target.closest('[data-cart-close]');
      if (closer) { Cart.close(); }
    });
    if (overlay) overlay.addEventListener('click', Cart.close);
    d.addEventListener('keydown', function (e) {
      if (!root.classList.contains('cart-open')) return;
      if (e.key === 'Escape') { Cart.close(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href],button:not([disabled]),input', drawer).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    var body = $('.drawer-body', drawer);
    body.addEventListener('click', function (e) {
      var line = e.target.closest('.line'); if (!line) return;
      var key = line.getAttribute('data-key'), input = $('[data-line-qty]', line);
      var stepBtn = e.target.closest('[data-line-step]');
      if (stepBtn) Cart.change(key, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-line-step'), 10));
      if (e.target.closest('[data-line-remove]')) Cart.change(key, 0);
    });
    body.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      Cart.change(e.target.closest('.line').getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
    });
    var pc = $('[data-preview-checkout]', drawer);
    if (pc) pc.addEventListener('click', function () {
      $('.checkout-msg', drawer).textContent = 'Preview only. On your Shopify store this button opens Shopify checkout.';
    });
    Cart.refresh();
  }

  /* ---------- buy form ---------- */
  function initBuy(scope) {
    $$('[data-buy]', scope).forEach(function (form) {
      var radios = $$('input[name="plan"]', form), qtyIn = $('input[name="quantity"]', form);
      var totalEl = $('[data-total]', form), spInput = $('input[name="selling_plan"]', form), msg = $('.form-msg', form);
      function current() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
      function update() {
        var r = current(), q = Math.max(1, Math.min(99, parseInt(qtyIn.value, 10) || 1));
        qtyIn.value = q;
        if (totalEl && r) totalEl.textContent = money(parseInt(r.getAttribute('data-price'), 10) * q);
        if (spInput && r) spInput.value = r.getAttribute('data-plan-id') || '';
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
      $$('[data-step]', form).forEach(function (b) {
        b.addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10); update(); });
      });
      qtyIn.addEventListener('change', update);
      update();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = current(), btn = $('[type="submit"]', form);
        if (msg) msg.textContent = '';
        btn.disabled = true;
        Cart.add({
          variantId: ($('input[name="id"]', form) || {}).value, planId: r.getAttribute('data-plan-id') || '',
          qty: parseInt(qtyIn.value, 10) || 1, price: parseInt(r.getAttribute('data-price'), 10),
          title: form.getAttribute('data-title'), planLabel: r.getAttribute('data-label'), image: form.getAttribute('data-image') || ''
        }).then(function () { Cart.open(btn); })
          .catch(function (err) { if (msg) msg.textContent = err.message; })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  function initSmil(scope) {
    $$('svg[data-smil]', scope).forEach(function (s) { if (reduce.matches && s.pauseAnimations) { s.pauseAnimations(); s.setCurrentTime(0); } });
  }

  function init(scope) {
    initSmil(scope);
    initReveal(scope); initCount(scope); initOffscreen(scope); initGallery(scope); initFaq(scope); initZoom(scope); initBuy(scope);
  }

  initNav(); initCart(); init(d);
  d.addEventListener('shopify:section:load', function (e) { initNav(); init(e.target); });
  window.IronMomCart = Cart;
})();

